var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
}, __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var src_exports = {};
__export(src_exports, {
  configureMedia: () => import_useMedia.configureMedia,
  getConfig: () => import_config.getConfig,
  getMedia: () => import_useMedia.getMedia,
  getThemes: () => import_config.getThemes,
  getToken: () => import_config.getToken,
  getTokenValue: () => import_config.getTokenValue,
  getTokens: () => import_config.getTokens,
  mediaKeyMatch: () => import_useMedia.mediaKeyMatch,
  mediaObjectToString: () => import_useMedia.mediaObjectToString,
  mediaQueryConfig: () => import_useMedia.mediaQueryConfig,
  mediaState: () => import_useMedia.mediaState,
  setNonce: () => import_insertStyleRule.setNonce,
  setupDev: () => import_config.setupDev,
  updateConfig: () => import_config.updateConfig,
  useMedia: () => import_useMedia.useMedia
});
module.exports = __toCommonJS(src_exports);
__reExport(src_exports, require("./Tamagui"), module.exports);
__reExport(src_exports, require("./createComponent"), module.exports);
__reExport(src_exports, require("./createShorthands"), module.exports);
__reExport(src_exports, require("./createTheme"), module.exports);
__reExport(src_exports, require("./createTamagui"), module.exports);
__reExport(src_exports, require("./createFont"), module.exports);
__reExport(src_exports, require("./createTokens"), module.exports);
__reExport(src_exports, require("./createVariable"), module.exports);
__reExport(src_exports, require("./createVariables"), module.exports);
__reExport(src_exports, require("./insertFont"), module.exports);
__reExport(src_exports, require("./styled"), module.exports);
__reExport(src_exports, require("./setupReactNative"), module.exports);
__reExport(src_exports, require("./interfaces/GetRef"), module.exports);
var import_config = require("./config"), import_insertStyleRule = require("./helpers/insertStyleRule");
__reExport(src_exports, require("./constants/constants"), module.exports);
__reExport(src_exports, require("./contexts/ComponentContext"), module.exports);
__reExport(src_exports, require("./_withStableStyle"), module.exports);
__reExport(src_exports, require("./helpers/createMediaStyle"), module.exports);
__reExport(src_exports, require("./helpers/createShallowSetState"), module.exports);
__reExport(src_exports, require("./helpers/createStyledContext"), module.exports);
__reExport(src_exports, require("./helpers/expandStyles"), module.exports);
__reExport(src_exports, require("./helpers/getExpandedShorthands"), module.exports);
__reExport(src_exports, require("./helpers/getSplitStyles"), module.exports);
__reExport(src_exports, require("./helpers/getStylesAtomic"), module.exports);
__reExport(src_exports, require("./createComponent"), module.exports);
__reExport(src_exports, require("./helpers/getThemeCSSRules"), module.exports);
__reExport(src_exports, require("./helpers/getVariantExtras"), module.exports);
__reExport(src_exports, require("./helpers/isTamaguiComponent"), module.exports);
__reExport(src_exports, require("./helpers/isTamaguiElement"), module.exports);
__reExport(src_exports, require("./helpers/matchMedia"), module.exports);
__reExport(src_exports, require("./helpers/mergeProps"), module.exports);
__reExport(src_exports, require("./helpers/normalizeColor"), module.exports);
__reExport(src_exports, require("./helpers/normalizeStyle"), module.exports);
__reExport(src_exports, require("./helpers/normalizeValueWithProperty"), module.exports);
__reExport(src_exports, require("./helpers/propMapper"), module.exports);
__reExport(src_exports, require("./helpers/proxyThemeToParents"), module.exports);
__reExport(src_exports, require("./helpers/proxyThemeVariables"), module.exports);
__reExport(src_exports, require("./helpers/pseudoDescriptors"), module.exports);
__reExport(src_exports, require("./helpers/themeable"), module.exports);
__reExport(src_exports, require("./helpers/themes"), module.exports);
__reExport(src_exports, require("./helpers/transformsToString"), module.exports);
var import_useMedia = require("./hooks/useMedia");
__reExport(src_exports, require("./hooks/useTheme"), module.exports);
__reExport(src_exports, require("./hooks/useThemeName"), module.exports);
__reExport(src_exports, require("./hooks/useConfiguration"), module.exports);
__reExport(src_exports, require("./hooks/useIsTouchDevice"), module.exports);
__reExport(src_exports, require("./hooks/useProps"), module.exports);
__reExport(src_exports, require("./hooks/useConfiguration"), module.exports);
__reExport(src_exports, require("./views/Slot"), module.exports);
__reExport(src_exports, require("./views/Stack"), module.exports);
__reExport(src_exports, require("./views/View"), module.exports);
__reExport(src_exports, require("./views/Text"), module.exports);
__reExport(src_exports, require("./views/Theme"), module.exports);
__reExport(src_exports, require("./views/ThemeProvider"), module.exports);
__reExport(src_exports, require("./views/FontLanguage"), module.exports);
__reExport(src_exports, require("./views/TamaguiProvider"), module.exports);
__reExport(src_exports, require("./views/Configuration"), module.exports);
__reExport(src_exports, require("@tamagui/use-did-finish-ssr"), module.exports);
__reExport(src_exports, require("@tamagui/use-event"), module.exports);
__reExport(src_exports, require("@tamagui/compose-refs"), module.exports);
__reExport(src_exports, require("@tamagui/helpers"), module.exports);
__reExport(src_exports, require("@tamagui/constants"), module.exports);
__reExport(src_exports, require("./setupHooks"), module.exports);
//# sourceMappingURL=index.js.map
